import styled from "styled-components";

import { FeaturesList, PermissionsList } from "@pages/login/components/lists";

const Container = styled.div`
  padding: 40px;
  max-width: 800px;
`;

export const PermissionsDialogContent = () => {
  return (
    <Container>
      <FeaturesList step="install" />
      <PermissionsList step="install" />
    </Container>
  );
};
